import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useDeleteAnwesenheit, useDeleteKunde } from "../../client/hooks";
import { useMutation, useQueryClient } from "react-query";
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from "material-ui-popup-state/hooks";

export default function DeleteAnwesenheitButton({ id }: { id: string }) {
  const mutate = useLoeschenAnwesenheit(id);
  const popupState = usePopupState({
    variant: "popover",
    popupId: `anwesenheit-${id}-deactivate`,
  });
  return (
    <>
      <IconButton
        sx={{ position: "absolute", top: 10, right: 10 }}
        {...bindTrigger(popupState)}
        aria-label="delete"
      >
        <DeleteIcon />
      </IconButton>
      <Dialog {...bindPopover(popupState)}>
        <DialogTitle id="alert-dialog-title">
          Anwesenheit wirlich löschen
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Sie sind dabei diese Anwesenheit zu löschen. Sind Sie sicher?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => popupState.close()} color="inherit">
            abbrechen
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              mutate.mutate();
              popupState.close();
            }}
          >
            löschen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
function useLoeschenAnwesenheit(id: string) {
  const deleteAnwesenheit = useDeleteAnwesenheit();
  const queryClient = useQueryClient();

  return useMutation(
    () => {
      return deleteAnwesenheit(id);
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries(["anwesenheiten", id]);
      },
    }
  );
}
